<template>
  <div>
    <vs-alert
      v-if="$validator.errors.all().length > 0"
      color="danger"
      title="Atenção!!"
      active="true"
      class="my-3"
      style="height: auto !important"
    >
      <ul>
        <li
          class="mb-2"
          v-for="error in $validator.errors.all()"
          :key="error.id"
        >
          {{ error }}
        </li>
      </ul>
    </vs-alert>

    <vs-row v-if="contaBancaria.status === 'MeusSaques'">
      <vs-row v-if="saques.length > 0">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card>
            <vs-collapse type="border">
              <vs-collapse-item v-for="item in saques" :key="item.idSaque">
                <div class="d-flex p-2" style="display: flex" slot="header">
                  <h4>Protocolo Saque: {{ item.idSaque }}</h4>
                  <vs-chip
                    class="mr-4 ml-3"
                    :color="getStatusBoletoColor(item.statusSaque)"
                    >{{ item.statusSaque }}</vs-chip
                  >
                </div>
                <vs-row>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-w="12"
                    vs-sm="12"
                    vs-xs="12"
                  >
                    <table class="table tabela table-bordered">
                      <tr v-if="contaBancaria.shortName">
                        <th class="uppercase">Conta Bancaria</th>
                        <td>{{ contaBancaria.shortName }}</td>
                      </tr>
                      <tr v-if="contaBancaria.agencia">
                        <th class="uppercase">Agencia</th>
                        <td>{{ contaBancaria.agencia }}</td>
                      </tr>
                      <tr v-if="contaBancaria.digitoAgencia">
                        <th class="uppercase">Digito Agencia</th>
                        <td>{{ contaBancaria.digitoAgencia }}</td>
                      </tr>
                      <tr v-if="contaBancaria.conta">
                        <th class="uppercase">Conta</th>
                        <td>{{ contaBancaria.conta }}</td>
                      </tr>
                      <tr v-if="contaBancaria.digitoConta">
                        <th class="uppercase">Digito Conta</th>
                        <td>{{ contaBancaria.digitoConta }}</td>
                      </tr>
                      <tr v-if="item.valor">
                        <th class="uppercase">Valor</th>
                        <td>{{ item.valor | currency }}</td>
                      </tr>
                      <tr v-if="formataDataUTCAux(item.creditadoEm)">
                        <th class="uppercase">Creditado em:</th>
                        <td>
                          {{ formataDataUTCAux(item.creditadoEm) }}
                        </td>
                      </tr>

                      <tr
                        v-if="item.statusSaque == 'EM ABERTO' && idEmpresa == 4"
                        style="display: flex"
                      >
                        <td>
                          <div class="vx-col" style="display: flex">
                            <vs-button
                              class="mr-2 mt-3"
                              v-tooltip="'Reprovar Saque'"
                              type="gradient"
                              color="danger"
                              icon="thumb_down"
                              @click="reprovarSaque(item)"
                            />
                            <vs-button
                              class="mr-2 mt-3"
                              v-tooltip="'Aprovar Saque'"
                              type="gradient"
                              color="success"
                              icon="thumb_up"
                              @click="aprovarSaque(item)"
                            />
                          </div>
                        </td>
                      </tr>
                    </table>
                  </vs-col>
                </vs-row>
              </vs-collapse-item>
            </vs-collapse>
          </vs-card>
        </vs-col>
      </vs-row>

      <vs-row v-if="semSaque">
        <vs-card>
          <div><h4>Ainda nao foi solicitado nenhum saque</h4></div>
        </vs-card>
      </vs-row>
    </vs-row>

    <vs-row style="display: block" v-if="contaBancaria.status === 'Novo'">
      <vs-row>
        <div class="vx-row mb-4" style="width: 100%">
          <div class="vx-col flex items-center" style="width: 100%">
            <div class="vx-col" style="width: 100%">
              <span>Selecione a conta de destino</span>
              <v-select
                :options="opcaoSelect"
                name="Conta Bancaria"
                id="Conta Bancaria"
                v-model="formSaque"
                v-validate="{ required: true }"
                :state="validateState('Conta Bancaria')"
                :danger="validateClass('Conta Bancaria')"
              ></v-select>
            </div>
          </div>
        </div>
      </vs-row>

      <vs-row v-if="formSaque">
        <div v-if="formSaque.id" class="vx-row mb-4 mt-3" style="width: 100%">
          <div class="vx-col" style="width: 100%">
            <div class="flex items-center">
              <div class="flex items-center" style="width: 100%">
                <span class="flex items-center">Dados da conta : </span>
              </div>
              <div class="flex items-center">
                <vs-button
                  color="warning"
                  type="border"
                  icon="edit"
                  v-tooltip="'Editar Conta Bancaria'"
                  @click.stop.prevent="editContaBancaria"
                ></vs-button>
              </div>
            </div>
            <vx-card class="mt-3 card">
              <div id="divSaldo" class="vx-col">
                <table class="table tabela2 table-bordered">
                  <tr v-if="contaBancaria.agencia">
                    <th class="uppercase">Agencia</th>
                    <td>{{ contaBancaria.agencia }}</td>
                  </tr>
                  <tr v-if="contaBancaria.digitoAgencia">
                    <th class="uppercase">Digito Agencia</th>
                    <td>{{ contaBancaria.digitoAgencia }}</td>
                  </tr>
                  <tr v-if="contaBancaria.conta">
                    <th class="uppercase">Conta</th>
                    <td>{{ contaBancaria.conta }}</td>
                  </tr>
                  <tr v-if="contaBancaria.digitoConta">
                    <th class="uppercase">Digito Conta</th>
                    <td>{{ contaBancaria.digitoConta }}</td>
                  </tr>
                </table>
              </div>
            </vx-card>
          </div>
        </div>
      </vs-row>

      <vs-row>
        <div class="vx-row mb-2" style="display: flex; width: 100%">
          <div class="vx-col" style="width: 100%">
            <div class="mt-4 mb-3">
              <span class="mb-3" style="font-size: initial"
                >Valor disponivel para saque:
                <b style="color: green">{{ saldo | currency }} </b>
              </span>
              <p class="textoModal mt-3">Informe o valor:</p>
              <money
                class="w-full vs-inputx vs-input--input normal mt-2"
                name="Valor Saque"
                id="Valor Saque"
                style="width: 100%"
                v-model="valorSaque"
                v-validate="{ required: true, min_value: 0.01 }"
                :state="validateState('Valor Saque')"
                :danger="validateClass('Valor Saque')"
                v-bind="money"
              ></money>
            </div>
          </div>
        </div>

        <vs-row>
          <div class="vx-row flex">
            <div class="vx-col flex">
              <!-- <div class="mb-4 mt-4 flex">
                  <input
                    id="fileUpload"
                    type="file"
                    hidden
                    v-on:change="selecionaFotoUpload"
                  />
                  <vs-button
                    color="primary"
                    type="border"
                    class="mr-3 mt-2 text-center"
                    @click="chooseFiles()"
                  >
                    <span>Nota Fiscal</span>
                    <feather-icon icon="UploadIcon" class="ml-2" />
                    <Br />
                    <div>
                      <vs-chip v-if="nomePdf" class="mt-1">
                        <vs-avatar icon-pack="feather" icon="icon-file" />
                        <span>{{ nomePdf }}</span>
                      </vs-chip>
                    </div>
                  </vs-button>
                </div> -->
              <vs-button
                @click="solicitarSaque({})"
                color="success"
                class="mb-4 mt-4 btn-block"
              >
                <span>Solicitar Saque</span>
              </vs-button>
            </div>
          </div>
        </vs-row>
      </vs-row>
    </vs-row>

    <vs-popup
      class="holamundo"
      :title="titleSideBar"
      :active.sync="addNewDataSidebar"
    >
      <formContaBancariaUsuario
        :key="contFormDesconto"
        :dados="formSaque"
        :contador="contFormDesconto"
        :modal="addNewDataSidebar"
        @close="fecharModal()"
      >
      </formContaBancariaUsuario>
    </vs-popup>

    <vs-alert
      v-if="valorIncorreto == true"
      color="danger"
      title="Atenção!!"
      active="true"
      class="my-3"
      style="height: auto !important"
    >
      <ul>
        <li class="mb-2">O Valor inserido é maior que saldo da conta</li>
      </ul>
    </vs-alert>
  </div>
</template>

<script>
import locale from '../../locale';
import Table from '../../ui-elements/table/Table.vue';
import service from '../../services';
import jwt from 'jsonwebtoken';
import moment from 'moment';
import vSelect from 'vue-select';
import { Money } from 'v-money';
import formContaBancariaUsuario from '../forms/formContaBancariaUsuario.vue';
import VxCard from '../../components/vx-card/VxCard.vue';

export default {
  props: {
    dados: {
      type: Array,
    },
    saldo: {
      type: Number,
    },
  },
  watch: {
    dados() {
      console.log(this.dados);
      this.buscaDados();
    },
  },
  data() {
    return {
      addNewDataSidebar: false,
      boletos: [],
      nomePdf: null,
      files: new FormData(),
      nossoNumero: '',
      formSideBar: 'ContaBancaria',
      titleSideBar: 'Adicionar Conta Bancária',
      placa: '',
      modelo: '',
      currency: 'R$',
      opcaoSelect: [],
      contFormDesconto: 0,
      dadosSideBar: {},
      contaBancaria: {},
      contaBancariaUsuario: {},
      valorSaque: 0,
      formContaBancaria: {},
      idEmpresa: null,
      url: null,
      money: {
        decimal: '.',
        thousands: '',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
      },
      formSaque: {
        id_empresa: null,
      },
      formIniciarSaque: {
        idContaBancaria: null,
        id_empresa: null,
        idUsuario: null,
        valor: null,
        idStatus: null,
        notaFiscal: null,
      },
      saques: [],
      semSaque: false,
      valorIncorreto: false,
      closeSaque: true,
    };
  },
  methods: {
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.formSaque.idUsuario = this.decoded.id_usuario;
      this.formSaque.id_empresa = this.decoded.id_empresa;
      this.idEmpresa = this.decoded.id_empresa;
      this.id_usuario = this.decoded.id_usuario;
    },
    fecharModal() {
      this.addNewDataSidebar = false;
    },
    buscaDados() {
      service
        .post('saque', 'get-saques', this.formSaque)
        .then((res) => {
          res.data.forEach((element) => {
            if (element.debito == true) {
              element.valorDebito = element.valor;
              this.valorTransacaoDebito = element.valorDebito;
            }

            if (element.credito == true) {
              element.valorCredito = element.valor;
              this.valorTransacaoCredito = element.valor;
            }

            this.dados.forEach((elementSel) => {
              if (elementSel.idSaque) {
                if (elementSel.idSaque == element.idSaque) {
                  console.log(this.dados, element);
                  let element2 = [element];
                  this.saques = element2;
                }
              } else {
                this.saques = res.data;
              }
            });
          });

          if (this.saques.length > 0) {
            this.$vs.loading.close();
          }
        })
        .catch((e) => {
          this.semSaque = true;
          this.$vs.loading.close(e);
          console.log(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não há transações para serem exibidas',
            color: 'danger',
          });
        });

      if (this.dados) {
        this.dados.forEach((element) => {
          this.contaBancaria = element;
        });
      }
    },
    selecionaArquivoPdf(event) {
      this.necessitaUpload = false;
      this.hasImage = true;
      this.imgUrl = null;
      this.nomeArquivo = event.name;
      this.image = { info: {} };
      this.image.info.name = this.nomeArquivo;
      this.image.blob = event.blob;
      if (event.base.indexOf('data:video') >= 0) {
        this.imgUrl = event.base;
        this.nomeArquivo = null;
        //
      }
    },
    selecionaFotoUpload(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;

      this.files.set('file', event.target.files[0], event.target.files[0].name);
      this.nomePdf = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload('Upload', 'NotaFiscal/' + this.nomePdf, this.files)
        .then((response) => {
          this.formIniciarSaque.notaFiscal = response;
          this.url = response;
          console.log(this.url);
          this.$vs.loading.close();
          //this.onSubmit();
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
        });
    },
    chooseFiles() {
      document.getElementById('fileUpload').click();
    },
    editContaBancaria() {
      this.contaBancaria.editar = true;
      this.contaBancariaUsuario = this.contaBancaria;
      this.$emit('close', this.contaBancariaUsuario);
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    solicitarSaque() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Para solicitar o saque tem que enviar esses dados, a conta bancaria e os dados do usuario
          this.formIniciarSaque.idContaBancaria =
            this.contaBancaria.idContaBancaria;
          this.formIniciarSaque.idUsuario = this.decoded.id_usuario;
          this.formIniciarSaque.email = this.decoded.email;
          this.formIniciarSaque.id_empresa = this.decoded.id_empresa;
          this.formIniciarSaque.valor = this.valorSaque;
          // Todo saque inicia com status 1 ('Em Aberto') está na tabela DOM_Status_Saque
          this.formIniciarSaque.idStatus = 1;

          const valorMaiorSaldo = Number(this.valorSaque) > Number(this.saldo);
          if (valorMaiorSaldo) {
            this.valorIncorreto = true;
          } else {
            service
              .post('saque', 'solicitar-saque', this.formIniciarSaque)
              .then((res) => {
                console.log(res);
                // this.saques.push(element);
                this.closeSaque = true;
                this.valorIncorreto = false;

                this.$emit('close', this.closeSaque);
                this.$vs.loading.close();
              })
              .catch((e) => {
                this.$vs.loading.close(e);
                console.log(e);
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: 'Não foi possivel solicitar o saque',
                  color: 'danger',
                });
              });
          }
        } else {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Existem campos não preenchidos',
            color: 'danger',
          });
        }
      });
    },
    aprovarSaque(item) {
      let objSend = {};

      objSend = item;
      // Status 5 == creditado (O saque quando aprovado, vai para creditado, status 5)
      objSend.idStatus = 5;
      objSend.idUsuario = this.decoded.id_usuario;
      objSend.idEmpresa = this.decoded.id_empresa;

      service
        .post('saque', 'aprovar-saque', objSend)
        .then((res) => {
          console.log(res);
          this.buscaDados();
          // this.saques.push(element);
        })
        .catch((e) => {
          this.$vs.loading.close(e);
          console.log(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possivel solicitar o saque',
            color: 'danger',
          });
        });
    },
    reprovarSaque(item) {
      let objSend = {};

      objSend = item;
      // Status 5 == creditado (O saque quando aprovado, vai para creditado, status 5)
      objSend.idStatus = 5;
      objSend.idUsuario = this.decoded.id_usuario;
      objSend.idEmpresa = this.decoded.id_empresa;

      service
        .post('saque', 'reprovar-saque', objSend)
        .then((res) => {
          console.log(res);
          this.buscaDados();
          // this.saques.push(element);
        })
        .catch((e) => {
          this.$vs.loading.close(e);
          console.log(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possivel reprovar o saque',
            color: 'danger',
          });
        });
    },
    addContaBancaria() {
      this.addNewDataSidebar = true;
      setTimeout(() => {
        this.$emit('close');
      }, 0);
    },
    formataDataUTCAux(data) {
      if (data) {
        return moment(data).utc().format('DD/MM/YYYY');
      }
    },
    concluido() {
      this.buscaDados();
    },
    getStatusBoletoColor(data) {
      if (data == 'EM ABERTO') return 'warning';
      if (data == 'EM ANALISE') return 'primary';
      if (data == 'REPROVADO') return 'danger';
      if (data == 'APROVADO - AGUARDANDO CRÉDITO') return 'warning';
      if (data == 'CREDITADO') return 'success';
    },
    getPlacaColor(data) {
      if (data) return 'dark';
    },
    openSideBar(dados) {
      dados.idConta == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    opemModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      var item = this.itens.find((x) => x.idConta == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != 'createdAt' &&
          element != 'updatedAt' &&
          element != 'deletedAt' &&
          element.indexOf('id') != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    validaVencido(item) {
      if (item.nomeStatus != 'Finalizado' && item.nomeStatus != 'Cancelado') {
        if (moment().diff(moment(item.dataVencimento), 'days') > 0) return true;
      }
      return false;
    },
  },
  created() {
    this.$validator.localize('ptBr', locale);
  },
  mounted() {
    this.getDecoded();
    this.buscaDados();
    if (this.dados) {
      console.log('dados', this.dados);
      this.dados.forEach((element) => {
        this.contaBancaria = element;
        // Somente para colocar o nome da conta bancaria do usuario
        this.opcaoSelect.push({
          id: element.idBanco,
          label: element.nomeConta + ' : ' + element.LongName,
        });
      });
    }
  },
  components: { formContaBancariaUsuario, 'v-select': vSelect, Money, VxCard },
};
Table;
</script>
<style scoped>
.div-show {
  display: 'block';
}
.div-hide {
  display: none;
}

.tabela {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid black;
}

.tabela2 {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important;
}
.con-vs-popup .vs-popup {
  width: 400px;
}

.tabela2 {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important ;
}
li.activeChild {
  border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
}
</style>
<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  border: 1px solid gray;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
.vdp-datepicker input {
  width: 100%;
}

.vs-button--text {
  display: flex;
  align-items: center;
}
</style>

<style>
.con-vs-popup .vs-popup {
  width: 600px !important;
}

.vs-button--text {
  display: flex;
  align-items: center;
}
</style>
